// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"styles_tooltip__3zH2s","moveLeft":"styles_moveLeft__3Pre0","bold":"styles_bold__2nBC1"};